import colorPallete, { headlineFonts, themeFontWeights } from "@dana/MobiusOverrides/styles/variables";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { ImgProps } from "@insite/mobius/Img";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import * as React from "react";
import { css } from "styled-components";

const enum fields {
    badge1Image = "badge1Image",   
    badge2Image = "badge2Image",   
    badge3Image = "badge3Image",   
    badge4Image = "badge4Image",   
    captionText = "captionText",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.badge1Image]: string;    
        [fields.badge2Image]: string;      
        [fields.badge3Image]: string;      
        [fields.badge4Image]: string;   
        [fields.captionText]: string;
    };
}
export interface FindNavBadgesWidgetStyles {
 badgeMain?: InjectableCss;
 badgeMainDiv?: InjectableCss;
 img?: ImgProps;
 pageTitle?: TypographyProps;
}
export const findNavBadgesWidgetStyles: FindNavBadgesWidgetStyles = {
  badgeMain: {        
        css: css`
               width: 100%;
    max-width: 760px;
    margin: 0 auto;
    text-align: center;           
        `,
    },
     badgeMainDiv: {        
        css: css`
                   display: flex;
    justify-content: center;
    flex-wrap: wrap;
    gap: 28px;
    margin-bottom: 20px;        
        `,
    },    
     img: {        
        css: css`
                          width: 88px;
    height: 88px;
    object-fit: contain;      
        `,
    },
    pageTitle: {
            css: css`
                font-size: ${headlineFonts.headline1SemiBoldSm.fontSize};
                line-height: ${headlineFonts.headline1SemiBoldSm.lineHeight};
                font-weight: ${themeFontWeights.semiBold};
                font-family: ${headlineFonts.headline1SemiBoldSm.fontFamily};
                color: ${colorPallete.grey800};
                padding-bottom: 43px;                
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(
                        theme,
                        [
                            null,
                            null,
                            css`
                                margin-bottom: 24px;
                                font-size: ${headlineFonts.headline1SemiBoldLg.fontSize};
                            `,
                        ],
                        "min",
                    )}
            `,
        },
}
const styles = findNavBadgesWidgetStyles;
type Props = OwnProps;

export const FindNavBadgesWidget: React.FC<Props> = ({ fields: f }) => {
    const badges = [
        { image: f.badge1Image },
        { image: f.badge2Image},
        { image: f.badge3Image},
        { image: f.badge4Image },    ];

    return (
        <>
        <Typography variant="h1" {...styles.pageTitle}>
                        
        </Typography>
        <StyledWrapper {...styles.badgeMain}>
            <StyledWrapper {...styles.badgeMainDiv}>
                {badges.map((b, i) =>
                    b.image ? (
                       <>
                            <img
                                src={b.image}                               
                                style={{ width: 88, height: 88, objectFit: "contain" }}
                            />
                       </>
                    ) : null,
                )}
            </StyledWrapper>
            {f.captionText && <Typography>{f.captionText}</Typography>}
        </StyledWrapper>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: FindNavBadgesWidget,
    definition: {
        group: "Common",
        fieldDefinitions: [
            { name: fields.badge1Image, fieldType: "General", editorTemplate: "ImagePickerField", defaultValue: "" },           
            { name: fields.badge2Image, fieldType: "General", editorTemplate: "ImagePickerField", defaultValue: "" },           
            { name: fields.badge3Image, fieldType: "General", editorTemplate: "ImagePickerField", defaultValue: "" },           
            { name: fields.badge4Image, fieldType: "General", editorTemplate: "ImagePickerField", defaultValue: "" },
                    
            {
                name: fields.captionText,
                fieldType: "Translatable",
                editorTemplate: "MultilineTextField",
                defaultValue:
                    "Quickly find parts with broad search capabilities, dynamic part descriptions, and extensive product resources.  View up-to-the-minute inventory conditions and place and track your order, in real time.  It’s all here at DanaAftermarket.com—and it’s never been easier.",
            },
        ],
    },
};

export default widgetModule;